import { Link } from 'react-router-dom';
import { Section, Video, Stat, ArrowLink } from '../ui';
import { DETECTIONS, STATS } from '../content';

const CAPABILITIES = [
  {
    n: '01',
    glyph: 'diamond',
    title: 'Flight Solutions',
    body: 'End-to-end drone operations for inspection, monitoring, and data collection — mission planning through data delivery. VLOS, BVLOS, remote, and dock-enabled, nationwide.',
    to: '/services/flight'
  },
  {
    n: '02',
    glyph: 'circle',
    title: 'Visual Intelligence',
    body: 'Computer vision that identifies, classifies, tracks, and inspects objects and conditions in imagery. Custom models built around real operational problems.',
    to: '/services/visual-intelligence'
  },
  {
    n: '03',
    glyph: 'square',
    title: 'Products & Innovation',
    body: 'Technology for complex operational challenges — including DroneClear, our patent-pending platform for managing and scaling enterprise drone programs.',
    to: '/products'
  }
];

export default function Home() {
  return (
    <main>
      <Section lg>
        <div className="split">
          <div>
            <div className="eyebrow-rule">
              <i />
              <span>Image capture &middot; Visual intelligence &middot; Innovation</span>
            </div>
            <h1 className="h-hero">
              From imagery
              <br />
              to insight.
            </h1>
            <p className="lede" style={{ maxWidth: '52ch' }}>
              Wanda brings together field operations, computer vision, and real-world problem
              solving. Engage us for a single capability, or connect them into a complete solution.
            </p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginTop: 36 }}>
              <Link className="btn btn--primary" to="/services">
                Explore our solutions
              </Link>
              <Link className="btn btn--ghost" to="/contact">
                Talk to us
              </Link>
            </div>
          </div>
          <Video
            src="/assets/hero-rail.mp4"
            poster="/assets/hero-rail-poster.jpg"
            alt="Aerial drone footage over a rail corridor, with people detected and labelled by the model in real time"
            ratio="4x3"
            caption="Aerial capture — rail corridor, live person detection"
            priority
          />
        </div>
      </Section>

      <Section>
        <div className="sec-head">
          <h2 className="h-sec">What we do</h2>
          <span className="eyebrow">Three capabilities</span>
        </div>
        <div className="grid-rule">
          {CAPABILITIES.map((c) => (
            <div className="card" key={c.n}>
              <div className="card__top">
                <span className="eyebrow eyebrow--accent">{c.n}</span>
                <span
                  className={`glyph${c.glyph === 'diamond' ? ' glyph--diamond' : ''}${
                    c.glyph === 'circle' ? ' glyph--circle' : ''
                  }`}
                />
              </div>
              <h3 className="h-card">{c.title}</h3>
              <p className="body" style={{ marginBottom: 22 }}>
                {c.body}
              </p>
              <ArrowLink to={c.to}>Explore</ArrowLink>
            </div>
          ))}
        </div>
      </Section>

      <Section alt>
        <div style={{ maxWidth: '60ch', marginBottom: 44 }}>
          <span className="eyebrow">Detection gallery</span>
          <h2 className="h-sec" style={{ margin: '16px 0 12px' }}>
            Visual intelligence in action
          </h2>
          <p className="body" style={{ fontSize: 16 }}>
            Models trained to find what matters in real-world imagery. Every frame below is live
            model output, boxed by the detector itself.
          </p>
        </div>
        <div className="grid-plain" style={{ '--min': '280px' }}>
          {DETECTIONS.map((d) => (
            <figure key={d.title}>
              <Video src={d.video} poster={d.poster} alt={d.alt} ratio="4x3" caption={d.frame} />
              <figcaption className="figcap">
                <span className="figcap__t">{d.title}</span>
                <span className="figcap__m">{d.meta}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </Section>

      <Section>
        <span className="eyebrow">Proven in the field</span>
        <div className="grid-rule" style={{ '--min': '220px', marginTop: 32 }}>
          {STATS.map((s) => (
            <Stat key={s.l} n={s.n} l={s.l} />
          ))}
        </div>
      </Section>
    </main>
  );
}
